<template>
  <div
    class="flex flex-col items-center gap-sm grow justify-center self-center w-1/3"
    data-test="empty-search-result"
  >
    <span class="typography-headline-2">{{ $t('noResults.label') }}</span>
    <i18n-t
      keypath="noResults.main"
      scope="global"
      tag="span"
      class="text-outline dark:text-outline-dark"
    >
      <template #doc>
        <span class="typography-body-2-bold"> {{ searchText }} </span>
      </template>
    </i18n-t>
    <span class="text-outline dark:text-outline-dark">
      {{ $t('noResults.secondary') }}
    </span>
  </div>
</template>
<script setup lang="ts">
defineProps<{
  searchText: string;
}>();
</script>
